import React from "react";
import { motion } from "framer-motion";
import {
  FaGraduationCap,
  FaUniversity,
  FaCalendarAlt,
  FaStar,
} from "react-icons/fa";

const educationData = [
  {
    degree: "B.Sc. in Computer Science and Engineering",
    school: "Bangladesh Army University of Science and Technology",
    year: "Jan. 2019 – Jan. 2023",
    description: "CGPA: 3.38",
    icon: <FaUniversity className="text-4xl text-teal-400" />,
  },
];

const Education: React.FC = () => {
  return (
    <section id="education" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl font-bold mb-12 text-center text-teal-400"
        >
          Education
        </motion.h2>
        <div className="max-w-3xl mx-auto">
          {educationData.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="mb-8 bg-gray-800 p-6 rounded-lg shadow-lg relative overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-teal-400 to-teal-600"></div>
              <div className="flex items-start">
                <div className="mr-6">{item.icon}</div>
                <div>
                  <motion.h3
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="text-2xl font-semibold mb-2 text-teal-400 flex items-center"
                  >
                    <FaGraduationCap className="mr-2 text-teal-500" />
                    {item.degree}
                  </motion.h3>
                  <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className="text-gray-300 mb-2 flex items-center"
                  >
                    <FaUniversity className="mr-2 text-teal-500" />
                    {item.school}
                  </motion.p>
                  <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className="text-gray-300 mb-2 flex items-center"
                  >
                    <FaCalendarAlt className="mr-2 text-teal-500" />
                    {item.year}
                  </motion.p>
                  <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    className="text-gray-300 flex items-center"
                  >
                    <FaStar className="mr-2 text-yellow-500" />
                    {item.description}
                  </motion.p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
